export default __webpack_public_path__ + "static/media/spark_71.8b947b87.png";